// Traducciones por subdominio FOB (flat keys en raíz de vue-i18n).
// Se cargan cuando el host es fob.delegat.es / delegat.test / iajur.com.

export default {
  // Traducciones específicas de campos para FOB
  AccountNumber: "Número de Cuenta FOB",
  "Additional costs": "Costos Adicionales FOB",
  Address: "Dirección",
  Amount: "Monto",
  Applied: "Aplicado",
  "Applied to": "Aplicado a",
  "Auto load packing list": "Carga automática de lista de empaque",
  "Autoload expenses": "Gastos de carga automática",
  "Autoload invoice supplier": "Factura de proveedor carga automática",
  "BL Number": "Número de BL",
  Balance: "Saldo",
  "Bank account": "Cuenta Bancaria",
  "Bank name": "Nombre del Banco",
  "Billing Address": "Dirección de Facturación",
  "Billing address": "Dirección de facturación",
  "Booking Number": "Número de Reserva",
  "Buyer refererence": "Referencia del Comprador",
  Cartons: "Cartones",
  Category: "Categoría",
  City: "Ciudad",
  Client: "Cliente",
  "Collect from": "Recoger de",
  Collection: "Cobranza",
  "Collection Number": "Número de Cobranza",
  "Collection date": "Fecha de Cobranza",
  Collections: "Cobranzas",
  Collects: "Cobros",
  Comment: "Comentario",
  Comments: "Comentarios",
  Contact: "Contacto",
  Container: "Contenedor",
  "Containers Involved": "Contenedores Involucrados",
  Country: "País",
  "Country of final destination": "País de Destino Final",
  "Country of origin": "País de Origen",
  CountryOfOrigin: "País de Origen",
  "Credit note": "Nota de Crédito",
  "Credit notes amount": "Monto de Notas de Crédito",
  Currency: "Moneda",
  "Currency IN": "Moneda IN",
  "Currency IS": "Moneda IS",
  "Currency PS": "Moneda PS",
  "Customer's commercial": "Comercial del Cliente",
  "Cut off documents": "Corte de Documentos",
  "Cut off physical": "Corte Físico",
  "DHL date": "Fecha DHL",
  "DHL number": "Número DHL",
  Date: "Fecha",
  "Date Released": "Fecha de Liberación",
  "Debit note": "Nota de Débito",
  "Debit notes amount": "Monto de Notas de Débito",
  Description: "Descripción",
  Documentation: "Documentación",
  "Done payments amount": "Monto de Pagos Realizados",
  Drafts: "Borradores",
  Emails: "Correos Electrónicos",
  "Estimated time of arrival (ETA)": "Tiempo Estimado de Llegada (ETA)",
  "Estimated time of departure (ETD)": "Tiempo Estimado de Salida (ETD)",
  Expense: "Gasto",
  Expenses: "Gastos",
  "Expiration of import permit": "Vencimiento del Permiso de Importación",
  "FR Comments": "Comentarios FR",
  File: "Archivo",
  Forwarder: "Agente de Carga",
  "Forwarding agent": "Agente de Envío",
  "Gate Out": "Salida de Puerta",
  "Gross weight": "Peso Bruto",
  Holder: "Titular",
  "IN Comments": "Comentarios IN",
  "IP applicable": "IP Aplicable",
  Iban: "IBAN",
  Imagen: "Imagen",
  "Import permit file": "Archivo de Permiso de Importación",
  "Import permit number": "Número de Permiso de Importación",
  "In stock": "En Stock",
  Incoterm: "Incoterm",
  "Incoterm IS": "Incoterm IS",
  "Incoterm PS": "Incoterm PS",
  "Instr Comments": "Comentarios de Instrucciones",
  "Instr Consignee": "Consignatario en Instrucciones",
  "Instr Consignee in certificate":
    "Consignatario en Instrucciones del Certificado",
  "Instr Invoice to": "Facturar a en Instrucciones",
  "Instr Labelling": "Etiquetado en Instrucciones",
  "Instr Notify": "Notificar en Instrucciones",
  "Instr Product": "Producto en Instrucciones",
  "Instr Shipper": "Embarcador en Instrucciones",
  "Intermediate port": "Puerto Intermedio",
  Invoice: "Factura",
  "Invoice Date": "Fecha de Factura",
  "Invoice Number": "Número de Factura",
  "Invoice products": "Productos de Factura",
  Language: "Idioma",
  "Letter of credit": "Carta de Crédito",
  "Loading date": "Fecha de Carga",
  Logo: "Logo",
  "Means of Convey": "Medio de Transporte",
  "Means of convey": "Medio de transporte",
  Name: "Nombre",
  "Name of Vessel": "Nombre del Buque",
  "Net weight": "Peso Neto",
  Nombre: "Nombre",
  Notify: "Notificar",
  Observations: "Observaciones",
  "Offer validity": "Validez de Oferta",
  "Original documents": "Documentos Originales",
  "PF Number": "Número PF",
  "PL Comments": "Comentarios PL",
  "Packing List": "Lista de Empaque",
  Paid: "Pagado",
  "Payment conditions": "Condiciones de Pago",
  "Payment date": "Fecha de Pago",
  "Payment supplier": "Pago a Proveedor",
  "Payment to": "Pago a",
  Payments: "Pagos",
  "Pending payments amount": "Monto de Pagos Pendientes",
  Phone: "Teléfono",
  "Port Of Delivery": "Puerto de Entrega",
  "Port Of Origin": "Puerto de Origen",
  "Port of delivery": "Puerto de entrega",
  "Port of incoterm": "Puerto de Incoterm",
  "Port of incoterm IS": "Puerto de Incoterm IS",
  "Port of incoterm PS": "Puerto de Incoterm PS",
  "Port of origin": "Puerto de origen",
  "Postal code": "Código Postal",
  Price: "Precio",
  Product: "Producto",
  "Product and price": "Producto y Precio",
  Products: "Productos",
  Proform: "COS",
  "Proform file": "Archivo de COS",
  "Proform number": "Número de COS",
  "Proform number Date": "Fecha de Número de COS",
  "Qty containers": "Cantidad de Contenedores",
  "Qty of Cont": "Cantidad de Cont",
  "Quantity of Containers": "Cantidad de Contenedores",
  "Raw Weight": "Peso en Bruto",
  "Reference number": "Número de Referencia",
  ReferenceNumber: "Número de Referencia",
  "Related file": "Archivo Relacionado",
  "Release Method": "Método de Liberación",
  "Release method": "Método de liberación",
  Remaining: "Restante",
  "Request Date of Payment": "Fecha de Solicitud de Pago",
  "Seal Number": "Número de Sello",
  "Shipper's commercial": "Comercial del Embarcador",
  Shipping: "COP",
  "Shipping Line": "Línea de COP",
  ShippingLine: "Línea de COP",
  Signature: "Firma",
  "Sizing ref": "Referencia de Talla",
  Status: "Estado",
  Supplier: "Proveedor",
  "Supplier Invoice number": "Número de Factura del Proveedor",
  "Supplier invoice date": "Fecha de Factura del Proveedor",
  "Supplier products": "Productos del Proveedor",
  Swift: "SWIFT",
  Title: "Título",
  "To apply": "A Aplicar",
  Total: "Total",
  "Total (USD)": "Total (USD)",
  "Total Additional Cost": "Costo Adicional Total",
  "Total Net Weight": "Peso Neto Total",
  "Total Price": "Precio Total",
  "Total Price Cont.": "Precio Total Cont.",
  "Total Products and price": "Total Productos y Precio",
  "Total Qty Cont.": "Cantidad Total Cont.",
  "Total Qty.": "Cantidad Total",
  "Total Qty. Cont.": "Cantidad Total Cont.",
  "Total Quantity": "Cantidad Total",
  "Total Raw Weight": "Peso en Bruto Total",
  "Total add cost": "Costo adicional total",
  "Total amount invoiced": "Monto total facturado",
  "Total billed": "Total facturado",
  "Total containers": "Total contenedores",
  "Total credit note": "Total nota de crédito",
  "Total debit note": "Total nota de débito",
  "Total expenses": "Total gastos",
  "Total invoice supplier": "Total factura proveedor",
  "Total net weight": "Peso neto total",
  "Total product price": "Precio total producto",
  "Total proform": "Total COS",
  "Total qty": "Cantidad total",
  "Total quantity": "Cantidad total",
  TransitTime: "Tiempo de Tránsito",
  Type: "Tipo",
  "Type of Cont": "Tipo de Cont",
  "Type of cont": "Tipo de contenedor",
  "Type of container": "Tipo de contenedor",
  "Type of document": "Tipo de documento",
  TypeOfContainer: "Tipo de Contenedor",
  "Unit price": "Precio unitario",
  "Unit qty": "Cantidad unitaria",
  "Validation date": "Fecha de validación",
  Website: "Sitio web",
  parentmodel: "modelo padre",
  shipping: "COP",
  shippings: "COPs",
  "unit price": "precio unitario",
  "unit qty": "cantidad unitaria",
  General: "General",
  "Import Permit": "Permiso de Importación",
  "Invoice (IN)": "Factura (IN)",
  "Invoice Supplier (IS)": "Factura Proveedor (IS)",
  Location: "Ubicación",
  "Packing List (PL)": "Lista de Empaque (PL)",
  "Proform Shipper": "COS Embarcador",
  "Proform Supplier (PS)": "COS Proveedor (PS)",
  Proforma: "COS",
  "Shipping Instructions": "Instrucciones de COP",
  Shippings: "COPs",
  Totals: "Totales",
  Freight: "Flete",
  Finance: "Finanzas",
  Documents: "Documentos",
  "Credit/Debit notes": "Notas de Crédito/Débito",

  // Traducciones específicas adicionales para FOB
  "FOB Specific": "Específico de FOB",
  "Custom Field": "Campo Personalizado",
  "Special Instructions": "Instrucciones Especiales",
};
